import * as defaultImport from "@splunk/visualizations/Pie";
export * from "@splunk/visualizations/Pie";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
